import AdminInput from "../../components/AdminInput";
import { useTranslation } from "react-i18next";

const PaymentMethod = ({
    loading,
    data
}) => {
    const { t } = useTranslation();
    return (
        <div className="card-body px-4">
            <h5 className="account-section-title py-2">Payment Method</h5>
            <hr className="hr-grey-account" />
            <div className="row d-flex align-items-start justify-content-between">
                <div className="col-12 col-lg-10">
                    <div className="row d-flex align-items-start justify-content-start mb-3">
                        <div className="col-12 col-lg-3 mb-2 mb-lg-0">
                            <p className="account-text-label mb-0">
                                Payment Method
                            </p>
                        </div>
                        <div className="col-12 col-lg-9">
                            <p className="account-text-value mb-0">
                                Credit Card
                            </p>
                        </div>
                    </div>
                </div>
                {
                    false && (
                        <div className="col-12 col-lg-2 d-flex align-items-start justify-content-end">
                            <button
                                type="button"
                                className="btn btn-edit-account px-2 py-2 mt-2 mt-lg-0"
                                onClick={() => { }}
                            >
                                {t("myPage.accountInformation.subMenu.paymentMethod.button")}
                            </button>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default PaymentMethod;
